export const formattedNumber = (number: number) =>
  number < 10 ? `0${number}`.slice(-2) : number;
